export const modalMixin = {
  data () {
    return { currentModal: { component: undefined, data: undefined } }
  },
  methods: {
    openModal (component, data) {
      this.currentModal = { component, data }
    },
    closeModal () {
      this.currentModal = { component: undefined, data: undefined }
    },
  },
}
